import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';
import JsBarcode from 'jsbarcode';
import printlogo from '../printpropertise/printlogoceylonika.png';

// Registering a font (optional, but good for consistency)
// Font.register({
//   family: 'Roboto',
//   fonts: [
//     { src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf', fontWeight: 'normal' },
//     { src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf', fontWeight: 'bold' },
//   ]
// });

export const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 9,
    fontFamily: 'Helvetica', // Or 'Roboto' if registered and preferred
  },
  headerSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 15,
  },
  logoAndCompanyInfo: {
    flexDirection: 'column',
    flex: 1,
  },
  logo: {
    width: 150,
    height: 50,
    marginBottom: 5,
  },
  companyInfoText: {
    fontSize: 8,
    lineHeight: 1.3,
    marginLeft: 5,
  },
  invoiceTitleSection: {
    textAlign: 'right',
    flex: 1,
  },
  invoiceTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 5,
    color: '#209c96',
  },
  invoiceInfoText: {
    fontSize: 9,
    lineHeight: 1.4,
  },
  barcode: {
    width: 85,
    height: 20,
    marginTop: 5,
    alignSelf: 'flex-end',
  },
  detailsSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 15,
  },
  detailBox: {
    width: '48%',
    backgroundColor: '#edfcfc',
    borderRadius: 5,
  },
  detailBoxHeader: {
    fontSize: 10,
    fontWeight: 'bold',
    marginBottom: 5,
    backgroundColor: '#a0fae8',
    padding: 8,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    color: '#333',
  },
  detailText: {
    fontSize: 9,
    lineHeight: 1.4,
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  table: {
    display: 'table',
    width: 'auto',
    border: '1 solid #a0fae8',
    marginBottom: 15,
  },
  tableRow: {
    flexDirection: 'row',
    backgroundColor: '#edfcfc',
    borderBottomWidth: 1,
    borderBottomColor: '#FFFFFF',
  },
  tableHeader: {
    backgroundColor: '#a0fae8',
    color: '#333',
    fontWeight: 'bold',
  },
  tableColHeader: {
    padding: 5,
    borderStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomColor: '#a0fae8',
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderRightWidth: 1,
    borderRightColor: '#FFFFFF',
    textAlign: 'center',
  },
  tableCol: {
    padding: 5,
    borderStyle: 'solid',
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderRightWidth: 1,
    borderRightColor: '#FFFFFF',
  },
  colCode: { width: '15%', textAlign: 'left' }, // Unchanged
  colName: { width: '30%', textAlign: 'left' }, // Reduced from 35%
  colQty: { width: '8%', textAlign: 'right' }, // Reduced from 10%
  colBP: { width: '12%', textAlign: 'right' }, // New column for BP
  colPrice: { width: '15%', textAlign: 'right' }, // Reduced from 20%
  colTotal: { width: '20%', textAlign: 'right' },
  summarySection: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 10,
  },
  summaryBox: {
    width: '48%',
    backgroundColor: '#edfcfc',
    borderRadius: 5,
  },
  summaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 2,
  },
  summaryLabel: { textAlign: 'left' },
  summaryValue: { textAlign: 'right', fontWeight: 'bold' },
  summaryTotalLabel: { fontWeight: 'bold', textAlign: 'left' },
  summaryTotalValue: { fontWeight: 'bold', textAlign: 'right' },
  summaryBoxHeader: {
    fontSize: 10,
    fontWeight: 'bold',
    backgroundColor: '#a0fae8',
    padding: 8,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    color: '#333',
    marginBottom: 5,
  },
  footer: {
    position: 'absolute',
    bottom: 40, // Further increased bottom to prevent edge printing issues
    left: 20,
    right: 20,
    textAlign: 'center',
    fontSize: 8,
    color: 'grey',
    paddingTop: 5,
  },
});

const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    return new Date(dateString).toLocaleDateString();
  } catch (e) {
    return dateString;
  }
};

const formatCurrency = (value) => {
  return parseFloat(value || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const generateBarcode = (text) => {
  if (!text) return null;
  try {
    const canvas = document.createElement('canvas');
    JsBarcode(canvas, text, {
      format: 'CODE128',
      displayValue: false,
      width: 2,
      height: 10,
      margin: 0,
    });
    return canvas.toDataURL('image/png');
  } catch (e) {
    console.error("Barcode generation failed:", e);
    return null;
  }
};

const OrderPrintContent = ({ orderData, pageNumber, totalPages }) => (
  <>
    {/* Header */}
    <View style={styles.headerSection}>
      <View style={styles.logoAndCompanyInfo}>
        <Image src={printlogo} style={styles.logo} />
        <View style={styles.companyInfoText}>
          <Text>Ceylonika Cosmetics (Pvt) Ltd</Text>
          <Text>154/11, Pushparama Road, Kadawatha</Text>
          <Text>www.ceylonikacosmetics.com | info@ceylonikacosmetics.com</Text>
          <Text>+94 112 92 44 20</Text>
        </View>
      </View>
      <View style={styles.invoiceTitleSection}>
        <Text style={styles.invoiceTitle}>SALES ORDER</Text>
        <Text style={styles.invoiceInfoText}>Order Ref: {orderData?.orderReferance || 'N/A'}</Text>
        <Text style={styles.invoiceInfoText}>Consultant ID: {orderData?.consultionId || 'N/A'}</Text>
        <Text style={styles.invoiceInfoText}>Date: {formatDate(orderData?.createDateTime)}</Text>
        {orderData?.orderReferance && (
          <Image style={styles.barcode} src={generateBarcode(orderData.orderReferance)} />
        )}
      </View>
    </View>

    {/* Customer and Shipping Details */}
    <View style={styles.detailsSection}>
      <View style={styles.detailBox}>
        <Text style={styles.detailBoxHeader}>Billing To / Consultant Details</Text>
        <View style={{ padding: 8 }}>
          <Text style={styles.detailText}>Name: {orderData?.orderBy || 'N/A'}</Text>
          <Text style={styles.detailText}>Address: {`${orderData?.customerBillAddress1 || ''}${orderData?.customerBillAddress2 ? `, ${orderData.customerBillAddress2}` : ''}, ${orderData?.customerBillCity || ''}, ${orderData?.customerBillDistrict || ''}`}</Text>
          <Text style={styles.detailText}>Phone: {orderData?.customerMobile}</Text>
          <Text style={styles.detailText}>Email: {orderData?.customerEmail}</Text>
        </View>
      </View>
      <View style={styles.detailBox}>
        <Text style={styles.detailBoxHeader}>Shipping Information</Text>
        <View style={{ padding: 8 }}>
          <Text style={styles.detailText}>Method: {orderData?.shippingMethod || 'N/A'}</Text>
          {orderData?.shippingMethod === "COURIER" && <Text style={styles.detailText}>Address: {`${orderData?.shippingAddress1 || 'N/A'}, ${orderData?.shippingAddress2 || ''}, ${orderData?.shippingCity || ''}, ${orderData?.shippingDistrict || ''}`}</Text>}
        </View>
      </View>
    </View>

    {/* Order Items Table */}
    <View style={styles.table} wrap={false}>
      <View style={[styles.tableRow, styles.tableHeader]}>
        <Text style={[styles.tableColHeader, styles.colCode]}>Code</Text> {/* Unchanged */}
        <Text style={[styles.tableColHeader, styles.colName, { textAlign: 'left' }]}>Item Name</Text>
        <Text style={[styles.tableColHeader, styles.colQty]}>Qty</Text>
        <Text style={[styles.tableColHeader, styles.colPrice]}>Unit Price</Text>
        <Text style={[styles.tableColHeader, styles.colTotal]}>Total</Text>
        <Text style={[styles.tableColHeader, styles.colBP]}>BP</Text> {/* New BP column header */}

      </View>
      {(orderData?.itemsList || []).map((item, index) => (
        <View style={styles.tableRow} key={item.orderItemId || index}>
          <Text style={[styles.tableCol, styles.colCode]}>{item.productCode}</Text>
          <Text style={[styles.tableCol, styles.colName]}>{item.productName}</Text>
          <Text style={[styles.tableCol, styles.colQty]}>{item.itemQty}</Text> {/* Unchanged */}
          <Text style={[styles.tableCol, styles.colPrice]}>{formatCurrency(item.itemUnitPrice || (item.itemSubTotal / (item.itemQty || 1)))}</Text> {/* Unchanged */}
          <Text style={[styles.tableCol, styles.colTotal]}>{formatCurrency(item.itemSubTotal)}</Text>
          <Text style={[styles.tableCol, styles.colBP]}>{item.itemTotalPoints}</Text> {/* New BP column content */}
        </View>
      ))}
    </View>

    {/* Summary */}
    <View style={styles.summarySection}>
      <View style={styles.summaryBox}>
        <Text style={styles.summaryBoxHeader}>Order Summary</Text>
        <View style={{ paddingHorizontal: 8, paddingBottom: 8 }}>
          <View style={styles.summaryRow}>
            <Text style={styles.summaryLabel}>Subtotal (Items):</Text>
            <Text style={styles.summaryValue}>{formatCurrency(orderData?.totalProductsCost)}</Text>
          </View>
          <View style={styles.summaryRow}>
            <Text style={styles.summaryLabel}>Handling Fee:</Text>
            <Text style={styles.summaryValue}>{formatCurrency(orderData?.totalHandlingFee)}</Text>
          </View>
          <View style={styles.summaryRow}>
            <Text style={styles.summaryLabel}>Shipping Cost:</Text>
            <Text style={styles.summaryValue}>{formatCurrency(orderData?.totalShippingCost)}</Text>
          </View>

          <View style={[styles.summaryRow, { marginTop: 5, borderTopWidth: 1, borderColor: '#a0fae8', paddingTop: 5 }]}>
            <Text style={styles.summaryTotalLabel}>Grand Total:</Text>
            <Text style={styles.summaryTotalValue}>{formatCurrency(orderData?.totalCost)}</Text>
          </View>

          {/* New rows for Total BV and Total BP */}
          <View style={[styles.summaryRow, { marginTop: 5, borderTopWidth: 1, borderColor: '#a0fae8', paddingTop: 5 }]}>
            <Text style={styles.summaryTotalLabel}>Total BV:</Text>
            <Text style={styles.summaryValue}>{formatCurrency(orderData?.totalBV)}</Text>
          </View>
          <View style={styles.summaryRow}>
            <Text style={styles.summaryTotalLabel}>Total BP:</Text>
            <Text style={styles.summaryValue}>{formatCurrency(orderData?.totalPoints)}</Text>
          </View>
        </View>
      </View>
    </View>

    {/* Footer with page number */}
    {pageNumber && totalPages && (
      <Text style={styles.footer} fixed>
        {orderData?.orderReferance ? `Order Ref: ${orderData.orderReferance} - ` : ''}
        Page {pageNumber} of {totalPages}
      </Text>
    )}
  </>
);

export default OrderPrintContent;